import React from 'react';
import PlanTechStepperContainer from '../../containers/plantechmng/PlanTechStepperContainer';

const PlanTechViewPage = () => {
  return <PlanTechStepperContainer />
};

export default PlanTechViewPage;
